import { A, Box, DashPlaceholder, Flex } from 'dash-ui';
import styled from 'styled-components';

export const Wrapper = styled(Box)`
  border-radius: ${({ theme }) => theme.space}px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.shadow1};

  @media ${({ theme }) => theme.devices.tablet} {
    p,
    a {
      max-width: 100%;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  @media ${({ theme }) => theme.devices.mobile} {
    box-shadow: none;
  }
`;

export const StyledAvatarPlaceholder = styled(DashPlaceholder)`
  border-radius: 100%;
`;

export const Anchor = styled(A)`
  text-decoration: none;
`;

export const GridWrapper = styled(Box)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: ${({ theme }) => theme.space * 3}px;

  @media ${({ theme }) => theme.devices.tablet} {
    gap: ${({ theme }) => theme.space * 2}px;
  }
`;

export const PropertyWrapper = styled(Box)`
  position: relative;
  cursor: pointer;

  :hover {
    & > div:last-child {
      height: 100%;

      p {
        opacity: 1;
      }
    }
  }
`;
export const PropertyItemOverlay = styled(Flex)`
  position: absolute;
  height: 0;
  bottom: 0;
  width: 100%;
  transition: height 0.3s ease-in-out;
  background: ${({ theme }) => theme.colors.setOpacity(theme.colors.b50, 60)};
  text-align: center;
  border-radius: ${({ theme }) => theme.space}px;

  p {
    opacity: 0;
    transition: opacity 0.3s ease-in-out;
  }
`;

export const ButtonsContainer = styled(Flex)`
  position: fixed;
  bottom: 0;
  left: 0;
  box-shadow: ${({ theme }) => theme.shadows.sidebarShadow};
  background-color: ${({ theme }) => theme.colors.white};
  z-index: 4;
`;

export const ContainerWrapper = styled(Box)<{ withBreadcrumb?: boolean }>`
  top: ${({ withBreadcrumb }) => (withBreadcrumb ? '107px' : '56px')};
`;
